/* cl-testimonial.js — carrossel do bloco de depoimentos.
   Reproduz o Swiper do concorrente: loop, slide ativo centralizado,
   slidesPerView 1.2 (mobile) / 2 (tablet, sem centralizar) / 3 (desktop). */
(function () {
  if (customElements.get('cl-testimonial-slider')) return;

  var GAP = 20;

  class ClTestimonialSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cl-tst__track');
      this.slides = Array.from(this.querySelectorAll('.cl-tst__slide'));
      this.count = parseInt(this.dataset.count, 10) || 1;
      if (!this.track || !this.slides.length) return;

      // O concorrente abre com o 1o depoimento no centro; como o track repete a
      // lista 3x, o centro inicial fica na 2a volta (ha slide dos dois lados).
      this.center = this.count;

      var prev = this.querySelector('.cl-tst__nav--prev');
      var next = this.querySelector('.cl-tst__nav--next');
      if (prev) prev.addEventListener('click', () => this.move(-1));
      if (next) next.addEventListener('click', () => this.move(1));

      this.querySelectorAll('.cl-tst__more').forEach((b) =>
        b.addEventListener('click', (e) => {
          var p = e.target.closest('.cl-tst__slide-text');
          var open = !p.classList.contains('is-expanded');
          p.classList.toggle('is-expanded', open);
          p.querySelector('.cl-tst__t-full').style.display = open ? 'inline' : '';
          p.querySelector('.cl-tst__t-short').style.display = open ? 'none' : '';
        })
      );

      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(this);
      this.layout();
    }

    disconnectedCallback() { if (this.ro) this.ro.disconnect(); }

    conf() {
      var w = window.innerWidth;
      if (w >= 1024) return { pv: 3, centered: true };
      if (w >= 768) return { pv: 2, centered: false };
      return { pv: 1.2, centered: true };
    }

    layout() {
      var c = this.conf();
      var wrapW = this.getBoundingClientRect().width;
      if (!wrapW) return;
      // mesma formula do Swiper: slidesPerView fracionario divide o gap tambem
      var slideW = (wrapW - GAP * (c.pv - 1)) / c.pv;
      this.slides.forEach((s) => {
        s.style.width = slideW + 'px';
        s.style.marginRight = GAP + 'px';
      });
      this.slideW = slideW;
      this.step = slideW + GAP;
      this.wrapW = wrapW;
      this.render();
    }

    move(dir) {
      this.center += dir;
      // loop: mantem o indice sempre na volta do meio
      if (this.center < this.count) this.center += this.count;
      if (this.center >= this.count * 2) this.center -= this.count;
      this.render();
    }

    render() {
      var c = this.conf();
      var visible = Math.round(c.pv);
      var start = c.centered ? this.center - Math.floor((visible - 1) / 2) : this.center;
      var x = -(start * this.step);
      if (c.centered) {
        x += (this.wrapW - (visible * this.slideW + (visible - 1) * GAP)) / 2;
      }
      this.track.style.transform = 'translate3d(' + x + 'px,0,0)';
      this.slides.forEach((s, i) =>
        s.classList.toggle('is-on', i >= start && i < start + visible)
      );
    }
  }

  customElements.define('cl-testimonial-slider', ClTestimonialSlider);
})();
